export default __webpack_public_path__ + "static/media/gsd.d1279814.jpg";